export default __webpack_public_path__ + "static/media/bo_4.8bf6a0d3.mp3";